import { CompanyBranding, ProjectOptions, Recommendation, WorkSpace } from '../types';

export class Project implements Project {
  constructor(
    id: number = null,
    createdAt: number = null,
    updatedAt: number = null,
    workSpaces: WorkSpace[] = [],
    options: ProjectOptions = null,
    recommendations: Recommendation[] = null,
  ) {
    this.id = id;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.workSpaces = workSpaces;
    this.options = options;
    this.recommendations = recommendations;
  }
}

export interface VersionsProject {
  project: Project;
  versionInfo: VersionInfo[]
}

export interface VersionInfo {
  isCurrent: boolean;
  createdAt?: number;
  name: string;
  date: string;
  time: string;
  version: number;
  referenceId: string;
}

export interface Project {
  id: number;
  createdAt: number;
  updatedAt: number;
  workSpaces: WorkSpace[];
  options: ProjectOptions;
  recommendations: Recommendation[];
  canUserAccessProject?: boolean;
  companyBranding?: CompanyBranding;
  isConverted?: boolean;
  sharedReferenceId?: string;
}
